<template>
    <div v-if="!absoluteLoader" v-bind="attrs" class="w-full">
        <div v-if="when" class="flex items-center justify-center">
            <div class="relative" :style="{ height: noHeight ? undefined : `${size}px`, width: `${size}px` }">
                <div class="absolute inset-0 flex items-center justify-center">
                    <Loader :size="size" />
                </div>
            </div>
        </div>
        <div v-else class="h-full w-full">
            <slot />
        </div>
    </div>
    <div v-else class="relative h-full w-full" v-bind="attrs">
        <div v-if="when" class="bg-dark-light absolute inset-0 flex items-center justify-center">
            <Loader :size="size" />
        </div>
        <slot />
    </div>
</template>

<script setup>
import { useAttrs } from 'vue'
import Loader from '@/components/Loader.vue'
const props = defineProps({
    when: { type: Boolean, default: true },
    size: { type: Number, default: 75 },
    noHeight: { type: Boolean, default: false },
    absoluteLoader: { type: Boolean, default: false },
})

// Accessing undeclared attributes
const attrs = useAttrs()

// Set inheritAttrs to false to prevent attributes being automatically added to the root element
defineOptions({
    inheritAttrs: false,
})
</script>
